module.exports = __webpack_public_path__ + "img/owners-associationpleno.336569ce.svg";